import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import OfflineScreen from 'components/OfflineScreen';
// styles
import ImportsTable from './ImportsTable/ImportsTable';
import { FormattedMessage } from 'react-intl';


const columns = {
  groups: 'general.groups',
  barns: 'general.barns',
  bins: 'general.bins',
  farms: 'general.farms',
  users: 'general.users',
};
class PushResults extends Component {

  state ={
    subNavLinks: [],
  };

  componentDidMount() {
    const { selectedArchiveImports, params } = this.props;
    // the archive row is only in the store after a click in the list, fall back to the route on a direct link
    const types = Array.isArray(selectedArchiveImports.type) ? selectedArchiveImports.type : [params.nameType];
    const subNavLinks = types.map((type) => ({
      label: <FormattedMessage id={columns[type]} />,
      link: `/imports/${params.id}/${type}`,
    }));
    this.setState({ subNavLinks });
  }

  render() {
    const { isOnline } = this.props;
    const { subNavLinks } = this.state;
    return (
      <div className="wrapperApi">
        <div className="BarnsheetsHome clearfix">
          {isOnline
            ? (
              <div className="small-12 column">
                <ImportsTable
                  subNavLinks={subNavLinks}
                />
              </div>
            )
            : <OfflineScreen />}
        </div>
      </div>
    );
  }
}

PushResults.propTypes = {
  isOnline: T.bool,
  selectedArchiveImports: T.object,
  params: T.shape({
    id: T.string.isRequired,
    nameType: T.string.isRequired,
  }).isRequired,
};

export default connect(
  (state) => ({
    isOnline: state.network.isOnline,
    selectedArchiveImports: state.importCSV.selectedArchiveImports,
  })
)(PushResults);
